// src/pages/Cartoes.jsx
import { useState } from 'react';
import { formatCurrency, currentMonthKey, monthLabel, getEntryBillKey } from '../services/billing';

const RAMPS = {
  blue:   { dot: '#6c8fff', bg: '#6c8fff20', label: 'Azul' },
  purple: { dot: '#a78bfa', bg: '#a78bfa20', label: 'Roxo' },
  teal:   { dot: '#34d399', bg: '#34d39920', label: 'Verde' },
  coral:  { dot: '#fb923c', bg: '#fb923c20', label: 'Laranja' },
  pink:   { dot: '#f472b6', bg: '#f472b620', label: 'Rosa' },
  amber:  { dot: '#fbbf24', bg: '#fbbf2420', label: 'Amarelo' },
  cash:   { dot: '#34d399', bg: '#34d39920', label: 'À vista' },
};

export default function Cartoes({ cards, entries, onAddCard, onDeleteCard }) {
  const [name, setName]       = useState('');
  const [closeDay, setClose]  = useState('');
  const [dueDay, setDue]      = useState('');
  const [color, setColor]     = useState('blue');
  const [loading, setLoading] = useState(false);

  const now = currentMonthKey();

  const cardTotals = {};
  entries.forEach(e => {
    if (getEntryBillKey(e, cards) === now)
      cardTotals[e.cardId] = (cardTotals[e.cardId] || 0) + e.val;
  });

  async function handleSubmit(e) {
    e.preventDefault();
    const cd = parseInt(closeDay), dd = parseInt(dueDay);
    if (cd < 1 || cd > 28) { alert('Dia de fechamento deve ser entre 1 e 28.'); return; }
    if (dd < 1 || dd > 31) { alert('Dia de vencimento deve ser entre 1 e 31.'); return; }
    setLoading(true);
    try {
      await onAddCard({ name: name.trim(), closeDay: cd, dueDay: dd, color });
      setName(''); setClose(''); setDue(''); setColor('blue');
    } catch (err) {
      alert('Erro ao salvar cartão.');
    } finally {
      setLoading(false);
    }
  }

  async function handleDelete(card) {
    const count = entries.filter(e => e.cardId === card.id).length;
    const msg = count > 0
      ? `Remover "${card.name}" e todos os ${count} lançamentos associados?`
      : `Remover o cartão "${card.name}"?`;
    if (!window.confirm(msg)) return;
    try { await onDeleteCard(card.id); }
    catch (err) { alert('Erro ao remover cartão.'); }
  }

  const cashCard = cards.find(c => c.color === 'cash');
  const realCards = cards.filter(c => c.color !== 'cash');

  return (
    <div className="content">
      <div className="page-header">
        <div>
          <div className="page-title">Cartões</div>
          <div className="page-subtitle">
            {realCards.length} cartão{realCards.length !== 1 ? 'ões' : ''} cadastrado{realCards.length !== 1 ? 's' : ''}
          </div>
        </div>
      </div>

      <div className="cards-grid">
        {realCards.map(c => {
          const r = RAMPS[c.color] || RAMPS.blue;
          const tot = cardTotals[c.id] || 0;
          return (
            <div className="card-tile" key={c.id}>
              <div className="card-tile-stripe" style={{ background: r.dot }} />
              <div className="card-tile-name">{c.name}</div>
              <div className="card-tile-meta">Fecha dia {c.closeDay} · Vence dia {c.dueDay}</div>
              <div className="card-tile-amount">{formatCurrency(tot)}</div>
              <div className="card-tile-period">fatura {monthLabel(now)}</div>
              <div className="card-tile-actions">
                <button className="btn btn-sm btn-danger" onClick={() => handleDelete(c)}>Remover</button>
              </div>
            </div>
          );
        })}

        <div className="add-card-tile" onClick={() => document.getElementById('c-name').focus()}>
          <svg style={{ width: 16, height: 16, stroke: 'currentColor', fill: 'none', strokeWidth: 2, strokeLinecap: 'round' }} viewBox="0 0 24 24">
            <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
          Novo cartão
        </div>
      </div>

      {/* Card À vista — aparece separado dos cartões de crédito */}
      {cashCard ? (
        <div style={{ marginBottom: '1.5rem', padding: '1rem 1.25rem', background: 'var(--bg-2)', border: '1px solid #34d39930', borderRadius: 'var(--radius-lg)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <div style={{ fontSize: 14, fontWeight: 500, color: '#34d399' }}>💵 Dinheiro / À vista</div>
            <div style={{ fontSize: 12, color: 'var(--text-3)', marginTop: 2 }}>
              Total este mês: <strong style={{ color: 'var(--text-1)' }}>{formatCurrency(cardTotals[cashCard.id] || 0)}</strong>
            </div>
          </div>
          <button className="btn btn-sm btn-danger" onClick={() => handleDelete(cashCard)}>
            Desativar
          </button>
        </div>
      ) : (
        <div style={{ marginBottom: '1.5rem', padding: '1rem 1.25rem', background: 'var(--bg-2)', border: '1px solid var(--border)', borderRadius: 'var(--radius-lg)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div>
            <div style={{ fontSize: 14, fontWeight: 500, color: '#34d399' }}>💵 Dinheiro / À vista</div>
            <div style={{ fontSize: 12, color: 'var(--text-3)', marginTop: 2 }}>Registre gastos pagos na hora, sem cartão</div>
          </div>
          <button className="btn btn-primary" onClick={() => onAddCard({ name: 'À vista', closeDay: 31, dueDay: 31, color: 'cash' })}>
            Ativar
          </button>
        </div>
      )}

      <form className="form-box" onSubmit={handleSubmit}>
        <div className="form-section-label">Adicionar cartão</div>

        <div style={{ fontSize: 12, color: 'var(--text-3)', marginBottom: 14, lineHeight: 1.6, padding: '10px 14px', background: 'var(--bg-3)', borderRadius: 'var(--radius-sm)', borderLeft: '2px solid var(--accent-border)' }}>
          Compras até o dia de fechamento entram na fatura do mês atual. Compras após o fechamento vão para a fatura do mês seguinte.
        </div>

        <div className="form-grid form-grid-4">
          <div className="field">
            <label>Nome do cartão</label>
            <input
              id="c-name"
              required
              placeholder="ex: Nubank"
              value={name}
              onChange={e => setName(e.target.value)}
            />
          </div>
          <div className="field">
            <label>Dia de fechamento</label>
            <input
              required
              type="number"
              min="1" max="28"
              placeholder="ex: 10"
              value={closeDay}
              onChange={e => setClose(e.target.value)}
            />
          </div>
          <div className="field">
            <label>Dia de vencimento</label>
            <input
              required
              type="number"
              min="1" max="31"
              placeholder="ex: 20"
              value={dueDay}
              onChange={e => setDue(e.target.value)}
            />
          </div>
          <div className="field">
            <label>Cor</label>
            <select value={color} onChange={e => setColor(e.target.value)}>
              {Object.entries(RAMPS).filter(([k]) => k !== 'cash').map(([k, v]) => (
                <option key={k} value={k}>{v.label}</option>
              ))}
            </select>
          </div>
        </div>

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Salvando...' : '+ Adicionar cartão'}
        </button>
      </form>
    </div>
  );
}